<template>
  <div class="appcontainer schedulingstart">
    <div class="appcontainer__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <div class="appcontainer__content">
      <div class="appcontainer__step schedulingstart__step">
        <el-steps :active="stepstatus" finish-status="success">
          <el-step title="设置类型"></el-step>
          <el-step title="选择日期与地点"></el-step>
          <el-step title="配置课程"></el-step>
          <el-step title="配置可见等级"></el-step>
          <el-step title="确认"></el-step>
        </el-steps>
      </div>

      <schedulingDetailPreview ref="schedulingDetailPreview"></schedulingDetailPreview>

      <div class="schedulingstart__step__divider">
        <el-divider class="divider"></el-divider>
      </div>

      <div class="schedulingstart__content">
        <SchedulingTypePanel
          v-show="stepstatus == 0"
          @onClickNext="onNext"
        ></SchedulingTypePanel>
        <SchedulingLocationAndDatePanel
          v-show="stepstatus == 1"
          ref="SchedulingLocationAndDatePanelRef"
          @onClickPrevious="onPrevious"
          @onClickNext="onNext"
        ></SchedulingLocationAndDatePanel>
         <SchedulingCoursePanel
          @onClickNext="onNext"
          @onClickPrevious="onPrevious"
          v-show="stepstatus == 2"
          ref="SchedulingCoursePanel"
        ></SchedulingCoursePanel>

        <SchedulingShowLevelPanel 
          v-show="stepstatus == 3"
          ref="schedulingShowLevelPanel"
          @onClickNext="onNext"
          @onClickPrevious="onPrevious"
          >

        </SchedulingShowLevelPanel>

        <schedulingStartPanlFour
          v-show="stepstatus == 4"
          ref="schedulingStartPanlFour"
          @onClickCompleted="onClickCompleted"
          @onClickPrevious="onPrevious"
        ></schedulingStartPanlFour>
      </div>

    </div>
  </div>
</template>




<script>

import SchedulingTypePanel from "@/views/module/start/comp/SchedulingTypePanel.vue"
import SchedulingShowLevelPanel from "@/views/module/start/comp/SchedulingShowLevelPanel.vue"
import SchedulingCoursePanel from "@/views/module/start/comp/schedulingCoursePanel.vue"
import schedulingStartPanlFour from "@/views/module/start/comp/schedulingStartPanlFour.vue"
import schedulingDetailPreview from "@/views/module/start/comp/components/schedulingDetailPreview.vue"
import SchedulingLocationAndDatePanel from "@/views/module/start/comp/SchedulingLocationAndDatePanel.vue"

import { schedulingSaveApi } from "@/api/module/scheduling/scheduling"

export default {
  name: "schedulingStart",
  components: {
    SchedulingTypePanel,
    schedulingDetailPreview,
    SchedulingLocationAndDatePanel,
    SchedulingCoursePanel,
    SchedulingShowLevelPanel,
    schedulingStartPanlFour
  },
  data() {
    return {
      stepstatus : 0,
      formdata: {
        studyclass : {},
        locations: {},
        courses: {}
      } ,

      loading : false

    };
  },
  methods:{
    init(){
      console.log("this.$refs",this.$refs)

      this.stepstatus = 0
      // this.stepstatus = 2
      // this.onNext();
    },

    onNext(data){

      console.log("onNext",data,this.stepstatus )
      this.stepstatus = this.stepstatus + 1;

      if(this.stepstatus == 1){
        this.formdata.studyclass = data;

        this.$refs.schedulingDetailPreview.initStudyClass(data);


        this.$nextTick(() => { 
          console.log("SchedulingLocationAndDatePanelRef",this.$refs.SchedulingLocationAndDatePanelRef)
          this.$refs.SchedulingLocationAndDatePanelRef.initStart();
        });


        this.$refs.schedulingShowLevelPanel.setType(data.type);


      }

      if(this.stepstatus == 2){
        console.log("配置课程")
        this.formdata.locations = data;

        this.$refs.SchedulingCoursePanel.init(); 
        this.$refs.SchedulingCoursePanel.setTimetype(data.timetype)

      }

      if(this.stepstatus == 3){
        console.log("配置可见等级")
        this.formdata.courses = data;

        // this.$refs.SchedulingCoursePanel.init(); 
      }

      if(this.stepstatus == 4){
        console.log("确认")
        this.formdata.showoptions = data;

        this.$refs.schedulingStartPanlFour.setSchedule(this.formdata)

      }

    },

    onPrevious(){
      this.stepstatus = this.stepstatus - 1;
    },


    onClickCompleted(hour){
      this.formdata.credithour = hour;
      console.log("hour",hour)


      if(this.loading)
        return;

      this.loading = true
      // save
      schedulingSaveApi(this.formdata)
        .then((r) => {
          this.$message.success("创建完成！")

          setTimeout(()=>{
            this.$router.push({
              path: "/standard/scheduling/scheduling"
            })
          },500)
        })
        .finally(()=>{
          this.loading = false
        })
    },


    initComponent(){
      // this.$refs.LocationSelectorBaidu.init();
    },



  },
  watch:{
  },
  mounted(){
    this.init();
  },
  created() {

  },
};



</script>

<style scoped>
.switch_operation {
  padding: 20px 5px 20px;
}
</style>